<template>
  <div class="header" v-if="$route.name !== 'Sequences'">
    <div class="top d-flex">
      <div class="p-2 d-flex">
        <router-link to="/" class="cursor-pointer">
          <img
            src="https://s3-us-west-2.amazonaws.com/pw2-logo/tair_logo_highdef_originalcolors.png"
            width="80"
            height="80"
            alt="tair"
            class="imgCont"
          />
        </router-link>
      </div>
      <div
        class="d-flex flex-column align-items-center align-self-center w-100"
      >
        <nav id="nav" class="self-center d-flex align-items-center mb-2">
          <ul class="nav-list d-flex align-items-center m-0 p-0">
            <li class="nav-item">
              <router-link to="/">Home</router-link>
            </li>
            <li class="nav-separator" aria-hidden="true">|</li>
            <li class="nav-item">
              <router-link to="/help">Help</router-link>
            </li>
            <li class="nav-separator" aria-hidden="true">|</li>
            <li class="nav-item">
              <router-link to="/contact">Contact</router-link>
            </li>
            <li class="nav-separator" aria-hidden="true">|</li>
            <li class="nav-item">
              <router-link to="/about/overview">About Us</router-link>
            </li>
            <li class="nav-separator" aria-hidden="true">|</li>
            <li class="nav-item">
              <a href="https://phoenixbioinfo.org/tair/#Pricing" target="_blank"
                >Subscribe</a
              >
            </li>
            <li class="nav-separator" aria-hidden="true">|</li>
            <li
              v-if="isLoginPending"
              class="nav-item login-pending"
              role="status"
              aria-live="polite"
            >
              <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
              Signing in&hellip;
            </li>
            <li v-if="!getLoggedIn && !isLoginPending" class="nav-item">
              <router-link to="/login">Login</router-link>
            </li>
            <li
              v-if="!getLoggedIn && !isLoginPending"
              class="nav-separator"
              aria-hidden="true"
            >
              |
            </li>
            <li v-if="!getLoggedIn && !isLoginPending" class="nav-item">
              <router-link to="/register">Register</router-link>
            </li>
            <li v-if="getLoggedIn" class="nav-item">
              <router-link to="/auth/logout">Logout</router-link>
            </li>
            <li v-if="getLoggedIn" class="nav-separator" aria-hidden="true">
              |
            </li>
            <li v-if="getLoggedIn" class="nav-item">
              <router-link to="/profile">
                <i class="fas fa-user" aria-hidden="true"></i> Profile
              </router-link>
            </li>
            <li
              class="nav-item ml-4"
              v-if="institution"
              style="font-size: 15px; font-style: italic"
            >
              <span>
                <b>Institution: {{ institution }}</b>
                <span class="ml-2">({{ status }})</span>
              </span>
            </li>
          </ul>
        </nav>
        <div class="search-wrapper">
          <GeneralSearch />
        </div>
      </div>
    </div>

    <div class="bottom" id="bottom-nav">
      <Navbar />
    </div>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar";
import GeneralSearch from "@/views/search/GeneralSearch.vue";
import { mapGetters } from "vuex";

export default {
  name: "HeaderComponent",
  components: {
    Navbar,
    GeneralSearch,
  },
  computed: {
    ...mapGetters("authProfile", ["getLoggedIn", "isLoginPending"]),
    ...mapGetters("subscriptionStatus", ["institution", "status"]),
  },
};
</script>

<style scoped lang="scss">
.header {
  background-color: #bbc9ce;
  max-width: 100%;
}

#nav {
  padding: 10px;

  @media (max-width: 480px) {
    padding: 5px;
  }

  .nav-list {
    list-style: none;

    @media (max-width: 640px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .nav-link {
    color: black;
    font-weight: bold;
  }

  .login-pending {
    font-style: italic;
    color: #333;
  }

  .nav-item {
    display: inline;

    @media (max-width: 480px) {
      white-space: nowrap;
    }
  }

  .nav-separator {
    display: inline;
    margin: 0 5px;
    color: black;

    @media (max-width: 480px) {
      margin: 0 2px;
    }
  }

  a {
    font-weight: bold;
    color: black;

    &.router-link-exact-active {
      color: #1d6100;
      background-color: #ffffff;
      padding: 2px;
      border-radius: 5px;
      box-shadow: 0 0 0 1px #1d6100;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
}

.search-wrapper {
  width: 100%;
  max-width: 100%;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 10px;
  }

  @media (max-width: 480px) {
    padding: 0 0.25rem;
    box-sizing: border-box;
  }
}

// Ensure content reflows properly on small screens (WCAG reflow)
@media (max-width: 640px) {
  .top {
    flex-wrap: wrap;
  }

  .imgCont {
    max-width: 100%;
    height: auto;
  }
}
</style>
